<template>
   <div class="settings-menu">
      <div v-for="tab in tabs" :key="tab.key" class="settings-menu__tab">
         <span :class="{ '-active': tab.key === selectedTab }" @click="changeTab(tab)">{{ $t(`general_tab.${tab.key}`) }}</span>

         <div v-if="tab.children" v-for="child in tab.children">
            <span
               class="child"
               :class="{ '-active': child.key === selectedChild }"
               @click="$emit('onChildChange', { child: child, tab: tab })"
               >{{ $t(`general_tab.${child.key}`) }}</span
            >
         </div>
      </div>
   </div>
</template>

<script>
export default {
   components: {},
   props: {
      tabs: Array,
      selectedTab: String,
      selectedChild: String,
   },

   emits: ['onTabChange', 'onChildChange'],
   methods: {
      changeTab(tab) {
         this.$emit('onTabChange', tab);
      },
   },
};
</script>

<style lang="scss" scoped>
.settings-menu {
   margin-top: 0.6153846154rem;
   font-size: 1.2307692308rem;
   &__tab {
      margin-bottom: 2.5rem;
      font-size: var(--nxt-font-large);
      color: var(--nxt-dark-grey);
      font-weight: bold;
      span {
         cursor: pointer;
      }
      span.-active {
         color: var(--nxt-main);
      }
   }
}

span:hover {
   color: var(--nxt-main-light);
}

.child {
   display: block;
   padding-top: var(--nxt-gutter-small);
   padding-bottom: var(--nxt-gutter-small);
   padding-left: var(--nxt-gutter-small);
   margin-bottom: var(--nxt-gutter-small);
   margin-top: var(--nxt-gutter-small);
   font-size: 0.9rem;
   font-weight: 400;
}
</style>

